import { KazooError } from "@kazoohr/types";
import dayjs from "dayjs";
import { isValidIso8601DateWithTimezone } from "./dateParsers";

/**
 * Parses the value and throws if it is not a valid ISO8601 date with timezone.
 */
export function parseStrict8601Date(value: string): Date {
  if (!isValidIso8601DateWithTimezone(value)) {
    throwInvalid(value);
  }
  const result = dayjs(value);
  if (!result.isValid()) {
    throwInvalid(value);
  }
  return result.toDate();
}

/**
 * Returns undefined for blank, otherwise calls parseStrict8601Date
 */
export function parseStrict8601DateOrUndefined(
  value?: string
): Date | undefined {
  if (!value) {
    return;
  }
  return parseStrict8601Date(value);
}

function throwInvalid(value: string) {
  throw new KazooError("Invalid ISO8601 date.", {
    translationKey: "packages.helpers.errors.invalidDate",
    translationValues: {
      value,
      dateFormat: "YYYY-MM-DDTHH:mm:ssZ or YYYY-MM-DDTHH:mm:ss+/-HH:MM",
    },
  });
}
